import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as cpfHelp from '@/cpf.help';
let FilterBtn = class FilterBtn extends Vue {
    toggle() {
        this.data.selected = !this.data.selected;
    }
    get id() {
        return cpfHelp.idify(this.data.name);
    }
    get iconClass() {
        return `${(this.data.selected ? "fas" : "far")} ${this.data.faIcon}`;
    }
    get linkTitle() {
        return this.data.selected ? `Remove filter for ${this.data.description}` : `Filter for ${this.data.description}`;
    }
};
tslib_1.__decorate([
    Prop()
], FilterBtn.prototype, "data", void 0);
FilterBtn = tslib_1.__decorate([
    Component
], FilterBtn);
export default FilterBtn;
